import { ModalMediaCardStructure } from 'common/components';
import { CEILINGS_CDN_PATH } from '../../ceilings-constants';
import { MoreInfoCardStructure } from '../ceilings-more-info';

export const LIGHTING_TYPE_LIST: ModalMediaCardStructure<MoreInfoCardStructure>[] = [
  {
    imgSrc: `${CEILINGS_CDN_PATH}/lighting-type/1.jpg/1.jpg`,
    modalImgSrc: `${CEILINGS_CDN_PATH}/lighting-type-popup/1.jpg/1.jpg`,
    title: 'lighting-type-section.floating.title',
    description: 'lighting-type-section.floating.description',
  },
  {
    imgSrc: `${CEILINGS_CDN_PATH}/lighting-type/2.jpg/2.jpg`,
    modalImgSrc: `${CEILINGS_CDN_PATH}/lighting-type-popup/2.jpg/2.jpg`,
    title: 'lighting-type-section.contour-lighting.title',
    description: 'lighting-type-section.contour-lighting.description',
  },
  {
    imgSrc: `${CEILINGS_CDN_PATH}/lighting-type/3.jpg/3.jpg`,
    modalImgSrc: `${CEILINGS_CDN_PATH}/lighting-type-popup/3.jpg/3.jpg`,
    title: 'lighting-type-section.light-lines.title',
    description: 'lighting-type-section.light-lines.description',
  },
  {
    imgSrc: `${CEILINGS_CDN_PATH}/lighting-type/4.jpg/4.jpg`,
    modalImgSrc: `${CEILINGS_CDN_PATH}/lighting-type-popup/4.jpg/4.jpg`,
    title: 'lighting-type-section.figured-lines.title',
    description: 'lighting-type-section.figured-lines.description',
  },
  {
    imgSrc: `${CEILINGS_CDN_PATH}/lighting-type/5.jpg/5.jpg`,
    modalImgSrc: `${CEILINGS_CDN_PATH}/lighting-type-popup/5.jpg/5.jpg`,
    title: 'lighting-type-section.illumination-canvas.title',
    description: 'lighting-type-section.illumination-canvas.description',
  },
  {
    imgSrc: `${CEILINGS_CDN_PATH}/lighting-type/6.jpg/6.jpg`,
    modalImgSrc: `${CEILINGS_CDN_PATH}/lighting-type-popup/6.jpg/6.jpg`,
    title: 'lighting-type-section.recessed-lamps.title',
    description: 'lighting-type-section.recessed-lamps.description',
  },
];
